import { render } from "./ActionCommentCreate.vue?vue&type=template&id=a6a3c6b4"
import script from "./ActionCommentCreate.vue?vue&type=script&lang=js"
export * from "./ActionCommentCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__